import { AddIconButton } from '@library/components/buttons';
import { CreateRoleModal } from '@library/components/modals/CreateRoleModal/CreateRoleModal';
import type { CreateRolesRequest } from '@library/types/role';
import { PageTitle } from '@library/components/PageTitle';
import { Roles } from '@bo-components/roles/Roles';
import { useRoles } from '@bo-hooks/roles/useRoles';
import { useSentrySetDashBoardTag } from '@bo-hooks/sentry/useSentrySetDashBoardTag';
import { useState } from 'react';
import { withProfiler } from '@sentry/react';

export const RolesDashboardView = () => {
  useSentrySetDashBoardTag({ dashboardName: 'Roles' });

  const [createRoleModalOpen, setCreateRoleModalOpen] = useState(false);

  const { createRole } = useRoles({ roles: undefined });

  const handleCreateRoleSubmit = async (role: CreateRolesRequest) => {
    await createRole({
      name: role.name,
      description: role.description
    }).then(() => {
      setCreateRoleModalOpen(false);
    });
  };

  return (
    <>
      <div className="flex w-auto flex-col gap-4 px-6 pb-2 pt-3">
        <div className="flex justify-between">
          <PageTitle title="Roles" />
          <AddIconButton
            className="bg-stankonia-100 hover:bg-stankonia-100 text-soClean-100 !size-auto px-2 py-1"
            label="Create role"
            onClick={() => setCreateRoleModalOpen(true)}
          />
        </div>

        <Roles />
      </div>

      <CreateRoleModal
        isOpen={createRoleModalOpen}
        onCancelModal={() => setCreateRoleModalOpen(false)}
        onSave={handleCreateRoleSubmit}
      />
    </>
  );
};

export const RolesDashboard = withProfiler(RolesDashboardView);
